import { useEffect, useState } from "react";
import { api, unwrap } from "../api/client";
import type { OutputLogs, OutputView } from "../api/types";
import { t } from "../lib/i18n";
import { CopyField, FormError, Modal } from "./ui";

/** Commande exacte et dernières lignes de log, rafraîchies toutes les 2 s. */
export function LogsModal({ output, onClose }: { output: OutputView; onClose: () => void }) {
  const [logs, setLogs] = useState<OutputLogs | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      unwrap(api.GET("/api/outputs/{output_id}/logs", { params: { path: { output_id: output.id } } }))
        .then((l) => alive && (setLogs(l), setError(null)))
        .catch((e: Error) => alive && setError(e.message));
    load();
    const timer = window.setInterval(load, 2000);
    return () => {
      alive = false;
      window.clearInterval(timer);
    };
  }, [output.id]);

  return (
    <Modal open wide title={t("Logs · {name}", { name: output.name })} onClose={onClose}>
      <div className="flex flex-col gap-3">
        <FormError message={error} />
        {logs && <CopyField label="cmd" value={logs.command} />}
        <pre className="max-h-[50vh] min-h-32 overflow-auto rounded-md border border-line bg-bg p-3 font-mono text-[12px] leading-relaxed text-muted">
          {logs ? (logs.logs.length ? logs.logs.join("\n") : t("Aucun message (tout va bien).")) : t("Chargement…")}
        </pre>
      </div>
    </Modal>
  );
}
